// Componente: EditDatosBancarios.jsx
import React from "react";
import Input from "../../../Elements/Input/Input";

const EditDatosBancarios = ({ values, handleChange }) => {
    return (
        <div className="seccion-formulario">
            <h4>Datos Bancarios</h4>
            <div className="row g-3">
                {/* Cuenta Nómina */}
                <div className="col-md-6">
                    <Input
                        value={values.clabeNomina}
                        label="CLABE nómina"
                        onChange={handleChange("clabeNomina")}
                    />
                </div>
                <div className="col-md-6">
                    <Input
                        value={values.bancoNomina}
                        label="Banco nómina"
                        onChange={handleChange("bancoNomina")}
                    />
                </div>
                <div className="col-md-6">
                    <Input
                        value={values.titularNomina}
                        label="Titular nómina"
                        onChange={handleChange("titularNomina")}
                    />
                </div>

                {/* Cuenta Adicional */}
                <div className="col-md-6">
                    <Input
                        value={values.clabeAdicional}
                        label="CLABE adicional"
                        onChange={handleChange("clabeAdicional")}
                    />
                </div>
                <div className="col-md-6">
                    <Input
                        value={values.bancoAdicional}
                        label="Banco adicional"
                        onChange={handleChange("bancoAdicional")}
                    />
                </div>
                <div className="col-md-6">
                    <Input
                        value={values.titularAdicional}
                        label="Titular adicional"
                        onChange={handleChange("titularAdicional")}
                    />
                </div>
            </div>
        </div>
    );
};

export default EditDatosBancarios;
